import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentDoctor } from "../../authDoctor/redux/thunks/doctorsThunks";

export default function useCurrentDoctor() {
  const dispatch = useDispatch();
  const currentDoctor = useSelector((state) => state.doctor?.user || null);
  const loading = useSelector((state) => state.doctor?.loading || false);
  const error = useSelector((state) => state.doctor?.error || null);

  useEffect(() => {
    if (!currentDoctor && !loading) {
      dispatch(getCurrentDoctor());
    }
  }, [dispatch, currentDoctor, loading]);

  return { currentDoctor, loading, error };
}
